// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, uploadMediaApi } from "../../Utils/Constants";
import { showToast } from "../../Helper/Toast";

export const hitUploadMedia = createAsyncThunk(
  "hitUploadMedia",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const url = ApiBaseUrl + uploadMediaApi;
      const response = await axios.post(url, payload, config);
      return response.data;
    } catch (error) {
      showToast(error.response.data.message, "error");
      throw error.response.data;
    }
  }
);

const UploadMediaSlice = createSlice({
  name: "uploadMediaReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearUploadMediaData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUploadMedia.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUploadMedia.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUploadMedia.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearUploadMediaData } = UploadMediaSlice.actions;
export default UploadMediaSlice.reducer;
